import React from 'react';
import Footer from 'react-bootstrap/Image';
const FooterDefault = () => {
    return(
        <Footer></Footer>
    )
}
export default FooterDefault;